module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "monitoring_wrp"
  }, [_c('div', {
    staticClass: "col-md-12 city_dropdown"
  }, [(!_vm.cityAdmin) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  })]) : _vm._e(), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-6 map-view"
  }, [_c('locationTracking')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('v-server-table', {
    ref: "surveyTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49202867", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49202867"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/location-tracking/monitoring.vue
// module id = 2312
// module chunks = 0